import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  Link,
  Divider,
  Container,
  Typography,
  Breadcrumbs,
} from "@mui/material";
import EventListSection from "../sections/_dashboard/EventListSection";
import SkillSelectionSection from "../sections/_dashboard/SkillSelectionSection";
import { useParams, useLocation } from "react-router-dom";
import EventCard from "../components/app/EventCard";
import SkillInputSection from "../sections/_dashboard/SkillInputSection";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------

export default function SkillInputPage() {
  const { skill_code } = useParams();

  const { state } = useLocation();
  const { skill, event } = state;

  const navigate = useNavigate();

  const eventName = event ? event.name_zh : "Unknown Event";

  const skillListLink = `/skill-list/${event.id}`;

  const handleNavEvent = (e) => {
    // console.debug("onDataInput");
    const options = {
      state: { event },
    };
    navigate(`/skill-list/${event.id}`, options);
  };

  return (
    <>
      <title> Dashboard | Minimal UI </title>

      <Container maxWidth="xl">
        {/* BreadCrumbs */}
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            Home
          </Link>

          <Link underline="hover" color="inherit" onClick={handleNavEvent}>
            {eventName}
          </Link>
          {/* <Link underline="hover" color="inherit" href={skillListLink}>
            Skill List
          </Link> */}
          <Typography color="text.primary">Skill Input</Typography>
        </Breadcrumbs>

        {/* Content  */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SkillInputSection skill={skill} event={event} />
          </Grid>
        </Grid>
        <Box>
          {/* {/* <pre>{skill_code}</pre> */}
          {/* <pre>{JSON.stringify(skill)}</pre>
          <pre>{JSON.stringify(event)}</pre> */}
        </Box>
      </Container>
    </>
  );
}
